/** The inbox for install questions and "it did not work" reports. */
export const SUPPORT_EMAIL = 'support@teslalocksound.com'

/** mailto link with a subject so the report arrives labelled. */
export function supportMailto(subject: string): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
}
